<div class="empty-items">
  <div class="empty-items__icon">
    <img *ngIf="!iconUrl" class="icon" src="/assets/img/no-checklist.svg" [alt]="'No Items' | translate" />

    <img *ngIf="iconUrl" class="icon" [src]="iconUrl" [alt]="'No Items' | translate" />
  </div>

  <ng-container *ngIf="!fullEntity">
    <div class="empty-items__title">
      <span translate>{{ 'No ' | translate }}</span
      ><span>{{ entity | translate }}</span
      ><span translate>&nbsp;found</span>
    </div>
  </ng-container>

  <ng-container *ngIf="fullEntity">
    <div class="empty-items__title mt-2 !text-svenn-Sunset">
      {{ fullEntity }}
    </div>
  </ng-container>
</div>
